module.exports = __webpack_public_path__ + "img/get-paid-image.af41bc15.png";